export default "__VITE_ASSET__jQo5V2uq__"